document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.getElementById('variant-specifications-wrapper');
  if (!wrapper) return;

  const specsBlocks = wrapper.querySelectorAll('.variant-specifications-content');
  if (!specsBlocks.length) return;

  const showSpecs = (id) => {
    specsBlocks.forEach((el) => {
      el.style.display = el.dataset.variantId === String(id) ? '' : 'none';
    });
  };

  if (window.globalVariantId) {
    showSpecs(window.globalVariantId);
  }

  document.addEventListener('globalVariantIdUpdated', (e) => {
    showSpecs(e.detail.variantId);
  });
});